var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBocachica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8648 45C74.0178 45 71.7098 47.308 71.7098 50.155V58.7467H82.879C85.726 58.7467 88.034 56.4387 88.034 53.5917V45H76.8648ZM84.5974 48.4367L76.8648 48.4367C75.9158 48.4367 75.1465 49.206 75.1465 50.155V55.31L82.879 55.31C83.828 55.31 84.5974 54.5407 84.5974 53.5917L84.5974 48.4367Z",
    fill: "#AAAAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6667 50.1552C53.6667 47.3082 55.9746 45.0002 58.8217 45.0002H69.9909V48.4369C69.9909 49.7572 69.4945 50.9615 68.6782 51.8736C69.4945 52.7856 69.9909 53.9899 69.9909 55.3102V58.7469L53.6667 58.7469V50.1552ZM66.5542 48.4369L58.8217 48.4369C57.8727 48.4369 57.1033 49.2062 57.1033 50.1552V55.3102H66.5542C66.5542 54.3618 65.7858 53.5928 64.8375 53.5919H58.8217V50.1552L64.8358 50.1552C65.7849 50.1552 66.5542 49.3859 66.5542 48.4369Z",
    fill: "#AAAAB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7508 50.155C89.7508 47.308 92.0588 45 94.9058 45H106.075V48.4367L94.9058 48.4367C93.9568 48.4367 93.1875 49.206 93.1875 50.155V55.31L106.075 55.31V58.7467H89.7508V50.155Z",
    fill: "#AAAAB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.948 58.7467L110.748 48.3804C111.493 46.3499 113.426 45 115.588 45H117.661C119.824 45 121.757 46.3499 122.501 48.3803L126.302 58.7467H122.642L121.382 55.31H111.899V55.2252L110.608 58.7467H106.948ZM120.121 51.8734L119.274 49.5634C119.026 48.8866 118.382 48.4367 117.661 48.4367L115.588 48.4367C114.867 48.4367 114.223 48.8866 113.975 49.5635L113.128 51.8734H120.121Z",
    fill: "#AAAAB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.232 63.845L109.431 74.2113H113.092L114.383 70.6898V70.7746H123.865L125.125 74.2113H128.786L124.985 63.8449C124.24 61.8145 122.308 60.4646 120.145 60.4646H118.072C115.909 60.4646 113.977 61.8145 113.232 63.845ZM121.758 65.028L122.605 67.338H115.612L116.459 65.0281C116.707 64.3512 117.351 63.9013 118.072 63.9013L120.145 63.9013C120.866 63.9013 121.51 64.3512 121.758 65.028Z",
    fill: "#AAAAB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0424 74.2113V60.4646H72.4791V65.6196H81.93V60.4646H85.3666V74.2113H81.93V69.0563H72.4791V74.2113H69.0424Z",
    fill: "#AAAAB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5206 74.2112V60.4645H87.084V74.2112H90.5206Z",
    fill: "#AAAAB6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.155 60.4648C53.308 60.4648 51 62.7728 51 65.6198V74.2115H67.3242V70.7748L54.4367 70.7748V65.6198C54.4367 64.6708 55.206 63.9015 56.155 63.9015H67.3242V60.4648H56.155Z",
    fill: "#AAAAB6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2401 65.6196C92.2401 62.7726 94.5481 60.4646 97.3951 60.4646H108.564V63.9013H97.3951C96.4461 63.9013 95.6768 64.6706 95.6768 65.6196V70.7746L108.564 70.7746V74.2113H92.2401V65.6196Z",
    fill: "#AAAAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBocachica);
export default __webpack_public_path__ + "static/media/bocachica.c450778c3cd729bad3dc97c24cf745d1.svg";
export { ForwardRef as ReactComponent };